var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1590,91a8,8,0,1,1-8,8A8,8,0,0,1,1590,91Zm-1,4-1,1v6l1,1,5-4Z","transform":"translate(-1582 -91)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }